import styled, { css } from 'styled-components'

export const Container = styled.div<{ $active: boolean }>(({ theme, $active }) => {
  const baseStyles = css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
    padding: ${theme.space['10']} ${theme.space['14']};
    background: ${theme.colors.white};
    border: ${theme.border.size['2']} solid ${theme.colors.gray500};
    border-radius: ${theme.border.radius['8']};
    color: ${theme.colors.black800};
    cursor: pointer;
    min-height: 6.5rem;
  `

  const activeStyles = $active
    ? css`
        border-color: ${theme.colors.marketShopBrand800};
        color: ${theme.colors.marketShopBrand800};
      `
    : ''

  return css`
    ${baseStyles}
    ${activeStyles}
  `
})

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;
    gap: ${theme.space['8']};
  `,
)

export const Texts = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['2']};
  `,
)

export const Title = styled.div(
  () => css`
    color: currentColor;
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.4rem;
    word-break: break-word;
  `,
)

export const SubTitle = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.black500};
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 1.5rem;
  `,
)

export const Radio = styled.div<{ $active: boolean }>(({ theme, $active }) => {
  const baseStyles = css`
    padding: ${theme.space['4']};
    background-color: ${theme.colors.gray100};
    border: ${theme.border.size['1']} solid ${theme.colors.gray500};
    border-radius: ${theme.border.radius['circle']};
    margin-left: auto;

    &::after {
      pointer-events: none;
      display: flex;
      content: ' ';
      width: 1rem;
      height: 1rem;
      background-color: transparent;
      border-radius: 50%;
    }
  `

  const activeStyles = $active
    ? css`
        border-color: ${theme.colors.marketShopBrand800};

        &::after {
          background-color: ${theme.colors.marketShopBrand800};
        }
      `
    : ''

  return css`
    ${baseStyles}
    ${activeStyles}
  `
})
